const PICKUP_VALUES = ["PICKUP", "PICK_UP", "STORE_PICKUP"];

export const normalizeFulfillmentType = (type) => {
	if (!type) return null;
	const formatted = type.toString().trim().toUpperCase();
	if (!formatted) return null;
	return PICKUP_VALUES.includes(formatted) ? "PICKUP" : "DELIVERY";
};

/** true = pickup, false = delivery, null = API did not tell us. */
export const isStorePickup = (orderLike) => {
	const type = normalizeFulfillmentType(orderLike?.fulfillmentType);
	return type === null ? null : type === "PICKUP";
};
